/**
 * Cache windows for reference data that is stable within a planning session
 * (regions, workers, production plants, allocation options).
 */

/** How long a cached response is served without a refetch. */
export const DEFAULT_STALE_TIME = 5 * 60 * 1000; // 5 minutes

/**
 * How long an unobserved entry survives before react-query drops it —
 * `cacheTime` on react-query v4, renamed `gcTime` in v5.
 *
 * Must stay above `DEFAULT_STALE_TIME`: the collection countdown starts when
 * the last observer unmounts, so an equal cache time evicts the entry at the
 * exact moment it would still have been fresh — a drawer closed and reopened
 * inside the stale window would refetch anyway, making the stale time a no-op
 * outside a fast reopen.
 */
export const DEFAULT_CACHE_TIME = 10 * 60 * 1000; // 10 minutes
